// /src/services/toast/toastManager.ts

import { toast } from "sonner";

import { DATABASE } from "../../types/tables-data";
import {
  ActionType,
  getDatabaseEntityActionMessage
} from "./toastConfiguration";

type ToastType = "success" | "info" | "warning";

class ToastManager {
  private static instance: ToastManager;

  static getInstance(): ToastManager {
    if (!ToastManager.instance) {
      ToastManager.instance = new ToastManager();
    }
    return ToastManager.instance;
  }

  // eslint-disable-next-line class-methods-use-this
  showToast(documentName: DATABASE, type: ToastType, action: ActionType): void {
    const message =
      type === "warning"
        ? "Something went wrong"
        : getDatabaseEntityActionMessage(documentName, action);
    const show =
      type === "success"
        ? toast.success
        : type === "info"
        ? toast.info
        : toast.error;
    show(message, { duration: 2000 });
  }
}

export { ToastManager, type ToastType };
